<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .candidate-info {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: utils.in_rem(4px);
    align-self: stretch;

    .name-container {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      align-items: center;

      .name-span {
        @include colors.color(black_90);
        @include mixins.h2();
      }
    }

    > .job-campaign-location-source {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: utils.in_rem(4px);

      .job,
      .campaign {
        @include colors.color(black_90);
        @include mixins.body2();
      }

      .location,
      .salary {
        @include colors.color(textGrey);
        @include mixins.body2();
      }
    }
  }
</style>

<script>
  // Stores
  import {
    candidateSourceStore,
    candidateStore,
    jobInfo,
    showEditContact,
    todosModalItemStore,
  } from "../stores";
  // Functions
  import { LOCALE } from "../utils";
  // Components
  import IconButton from "@sourcewhale/shared/svelte-design-system/components/atoms/IconButton.svelte";
  import SourcedViaTag from "@sourcewhale/shared/svelte-design-system/components/atoms/TagsAndChips/SourcedViaTag.svelte";
  import JobInfo from "../../../elements/ProfileContactSideBarShared/JobInfo.svelte";
  import CampaignInfo from "./CampaignInfo.svelte";

  const isTodo = $derived($todosModalItemStore?.toDoId);

  const source = $derived($candidateSourceStore.source);
  const sourceName = $derived($candidateSourceStore.sourceName);

  const status = $derived($candidateStore?.status);
  const campaignId = $derived($candidateStore?.campaignId);
  const pendingCampaign = $derived($candidateStore?.pendingCampaign);

  const editContactButtonProps = {
    icon: "far fa-user-pen",
    size: "medium",
    color: "primary_50",
    mouseEnterColor: "primary_60",
    focusColor: "primary_70",
    onclick: () => {
      $showEditContact = true;
    },
  };

  let date = $state(new Date());
  const startTicking = () => {
    const interval = setInterval(() => {
      date = new Date();
    }, 1000);

    return {
      destroy: () => {
        clearInterval(interval);
      },
    };
  };
</script>

<div class="candidate-info" use:startTicking>
  <div class="name-container">
    <span class="name-span">{$jobInfo?.candidateName}</span>
    <!-- Edit contact button -->
    <IconButton {...editContactButtonProps} />
  </div>
  <div class="job-campaign-location-source">
    <div class="job"><JobInfo {...$jobInfo} /></div>
    {#if !isTodo && ((status === "active" && campaignId) || pendingCampaign)}
      <div class="campaign"><CampaignInfo /></div>
    {/if}
    {#if $jobInfo.candidateLocation || $jobInfo.timezone || $jobInfo.skeleton}
      {@const { candidateLocation, timezone, skeleton } = $jobInfo}
      <!-- timezone cannot be an empty string for DateTimeFormat -->
      {@const time = timezone
        ? new Intl.DateTimeFormat(LOCALE, {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
            timeZoneName: "short",
            timeZone: timezone,
          }).format(date)
        : ""}
      <div class="location" class:skeleton>
        {#if candidateLocation && timezone}
          {candidateLocation}, {time}
        {:else if candidateLocation}
          {candidateLocation}
        {:else if timezone}
          {time}
        {/if}
      </div>
    {/if}
    {#if source || sourceName}
      <SourcedViaTag {source} {sourceName} />
    {/if}
  </div>
</div>
